import script from "./TitleSubtitle.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleSubtitle.vue?vue&type=script&setup=true&lang=js"

import "./TitleSubtitle.vue?vue&type=style&index=0&id=4faa18e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4faa18e4"]])

export default __exports__